import { render, staticRenderFns } from "./TramoRutaForm.vue?vue&type=template&id=cdaf9b9c"
import script from "./TramoRutaForm.vue?vue&type=script&lang=js"
export * from "./TramoRutaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports